import React, { useState } from 'react';
import { styled, createTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { DynamicValue } from '@fulcrumapp/fulcrum-core';
import Drawer from '@mui/material/Drawer';
import ChecklistForm from './checklist-form';
import Button from '../../components/button';
import { getChecklistCompletionText } from './utils';
import LocalStoragePreferences from '../../utils/local-storage-preferences';
import CustomDrawer from '../../shared/material_components/custom-drawer';

interface Props {
  open: boolean;
  onClose: () => void;
  value: DynamicValue;
  onChange: (value: DynamicValue) => void;
}

const theme = createTheme();

const CloseButton = styled(IconButton)({
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500],
});

const FillOutChecklistDialog = ({
  open,
  onClose,
  value,
  onChange,
}: Props) => {
  const originalChecklistValue = new DynamicValue(
    value.element,
    value.items[0] ? [value.items[0].toJSON()] : [],
  );
  const [checklistValue, setChecklistValue] = useState(originalChecklistValue);

  const handleSaveChanges = () => {
    onChange(checklistValue);
    onClose();
  };

  const localStorage = new LocalStoragePreferences();
  const useDrawer = localStorage.useDrawerInEditor();
  const title = `Checklist ${getChecklistCompletionText(checklistValue)}`;

  return useDrawer ? (
    <CustomDrawer
      open={open}
      onNegative={onClose}
      title={title}
      onPositive={handleSaveChanges}
      positive="Save Changes"
    >
      <ChecklistForm
        value={originalChecklistValue}
        onChange={setChecklistValue}
      />
    </CustomDrawer>
  ) : (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        Checklist (
        {getChecklistCompletionText(checklistValue)}
        )
        <CloseButton aria-label="close" onClick={onClose} size="large">
          <CloseIcon />
        </CloseButton>
      </DialogTitle>

      <DialogContent dividers sx={{ width: 500, padding: theme.spacing(2) }}>
        <ChecklistForm
          value={originalChecklistValue}
          onChange={setChecklistValue}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSaveChanges} color="secondary">
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FillOutChecklistDialog;
